import React, { useState } from "react";
import futuBot from "../../imagenes/FutuBot.png";

const WHATSAPP_URL =
  "https://api.whatsapp.com/send/?phone=593992424957&text&type=phone_number&app_absent=0";

const styles = {
  container: {
    position: "fixed",
    bottom: "70px",
    right: "15px",
    zIndex: 1000,
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },
  bubble: {
    position: "relative",
    backgroundColor: "#ffffff",
    color: "#333333",
    padding: "10px 16px",
    borderRadius: "16px",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
    fontSize: "14px",
    fontWeight: 600,
    whiteSpace: "nowrap",
    animation: "futubot-bounce 2.5s ease-in-out infinite",
  },
  bubbleClose: {
    position: "absolute",
    top: "-6px",
    right: "-6px",
    width: "18px",
    height: "18px",
    borderRadius: "50%",
    backgroundColor: "#999999",
    color: "#ffffff",
    border: "none",
    fontSize: "11px",
    lineHeight: "18px",
    padding: 0,
    cursor: "pointer",
  },
  link: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "60px",
    height: "60px",
    borderRadius: "50%",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.25)",
    transition: "transform 0.2s ease-in-out",
    animation: "futubot-pulse 2.5s ease-in-out infinite",
  },
  image: {
    width: "100%",
    height: "100%",
    objectFit: "contain",
    borderRadius: "50%",
  },
};

function WhatsappFloatingButton() {
  const [showBubble, setShowBubble] = useState(true);

  return (
    <>
      <style>{`
        @keyframes futubot-pulse {
          0%, 100% { box-shadow: 0 4px 12px rgba(0,0,0,0.25), 0 0 0 0 rgba(37,211,102,0.5); }
          50% { box-shadow: 0 4px 12px rgba(0,0,0,0.25), 0 0 0 10px rgba(37,211,102,0); }
        }
        @keyframes futubot-bounce {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-4px); }
        }
      `}</style>
      <div style={styles.container}>
        {showBubble && (
          <div style={styles.bubble}>
            ¡Hola! 👋 Soy FutuBot
            <button
              type="button"
              aria-label="Cerrar mensaje"
              style={styles.bubbleClose}
              onClick={(e) => {
                e.preventDefault();
                setShowBubble(false);
              }}
            >
              ×
            </button>
          </div>
        )}
        <a
          href={WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Chatear por WhatsApp"
          style={styles.link}
          onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.08)")}
          onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
        >
          <img src={futuBot} alt="FutuBot - Chatear por WhatsApp" style={styles.image} />
        </a>
      </div>
    </>
  );
}

export default WhatsappFloatingButton;
